import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/img/logodms1.png';
import { login } from '../../services/auth';
import { TOKEN, USER_TYPE, USER_ID } from '../../api/axios';
import { MessageWithIcon } from '../common/messagePopup';

const Login = () => {
  const [username, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async e => {
    e.preventDefault();
    setLoading(true);

    const data = { username, password };

    login(data)
      .then(response => {
        localStorage.setItem(TOKEN, response?.access);
        sessionStorage.setItem(USER_TYPE, response?.user.user_type); // store token if present
        sessionStorage.setItem(USER_ID, response?.user.id); // store token if present
        MessageWithIcon('Login successful', 'success');
        navigate('/dashboard');
      })
      .catch(err => {});

    setLoading(false);
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card p-4 shadow" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-4">
          <img src={logo} alt="DMS Logo" style={{ width: '100px' }} />
          <h3 className="mt-3">Login</h3>
        </div>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Username</label>
            <input
              type="text"
              className="form-control"
              required
              value={username}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter Username"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
